// extracted by mini-css-extract-plugin
export default {"container":"UserNav_container__5LSg+","link":"UserNav_link__3ubqE","text":"UserNav_text__pwhTH"};